import {
  takeLatest, cancel,
} from 'redux-saga/effects';

import * as cardActions from '../actions';

export const config = {
  action: cardActions.setStatus.type,
  method: takeLatest,
};

export function* func({ payload }: cardActions.ISetStatusPayload) {
  if (typeof window === 'undefined') {
    yield cancel(); return;
  }

  if (payload.status !== 'ready' || window.parent === window) {
    yield cancel(); return;
  }

  const message = { sender: 'card-snacks-web-player', type: 'CARD_READY' };
  window.parent.postMessage(message, '*');
}
